import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, CircularProgress } from "@mui/material";

const LoadingElement = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        padding: "8px 0",
      }}
    >
      <CircularProgress sx={{ color: theme.palette.primary.mainHover }} />
    </Box>
  );
};

export default LoadingElement;